<template>
  <div class="scene_add">
    <div class="left">
      <scene-round :device="b" v-for="b in bulbs" :key="`bulb_${b.name}`" @change="(c)=>{b.checked=c}">
        <img :src="getLightIcon(b)" style="width:60px " slot="icon"/>
        <div class="pd20">
          <el-form label-width="60px">
            <el-form-item label="开关：">
              <div class="text-right">
                <img :src="getIcon(b.state)" class="pointer" style="width: 80px" @click="b.state=!b.state"/>
              </div>
            </el-form-item>
            <template>
              <el-form-item label="亮度：" v-if="b.enableBR===1">
                <div class="form">
                  <range-slider
                          class="slider"
                          min="0"
                          max="100"
                          step="1"
                          v-model="b.br"
                  />
                  <span v-text="`${b.br}%`"></span>
                </div>
              </el-form-item>
              <el-form-item label="色温：" v-if="b.enableCCT===1">
                <div class="form">
                  <range-slider
                          class="slider"
                          min="2700"
                          max="6500"
                          step="100"
                          v-model="b.cct"
                  />
                  <span v-text="`${b.cct}K`"></span>
                </div>
              </el-form-item>
            </template>
          </el-form>
        </div>
      </scene-round>
    </div>
    <div class="right">
      <el-form label-width="60px">
        <el-form-item label="开关：">
          <div class="text-right">
            <img :src="getIcon(device.state)" class="pointer" style="width: 80px" @click="device.state=!device.state"/>
          </div>
        </el-form-item>
        <template v-if="zone&&zone.advanced===1">
          <el-form-item label="亮度：" v-if="zone&&zone.enableBR===1">
            <div class="form">
              <range-slider
                      class="slider"
                      min="0"
                      max="100"
                      step="1"
                      v-model="device.br"
              />
              <span v-text="`${device.br}%`"></span>
            </div>
          </el-form-item>
          <el-form-item label="色温：" v-if="zone&&zone.enableCCT===1">
            <div class="form">
              <range-slider
                      class="slider"
                      min="2700"
                      max="6500"
                      step="100"
                      v-model="device.cct"
              />
              <span v-text="`${device.cct}K`"></span>
            </div>
          </el-form-item>
        </template>
      </el-form>
    </div>
  </div>
</template>

<script>
import RangeSlider from 'vue-range-slider'
import 'vue-range-slider/dist/vue-range-slider.css'
import { mapState } from 'vuex'
import SceneRound from './Round'

export default {
  name: 'SceneLight',
  props: {
    command: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return { device: { br: 100, cct: 6500, state: 1 }, copy: {}, bulbs: [] }
  },
  computed: {
    ...mapState(['lights', 'zone', 'lightsOrign'])
  },
  components: {
    SceneRound,
    RangeSlider
  },
  watch: {
    lights () {
      this.bulbs = this.lights.map(d => {
        return { deviceId: d.deviceId, name: d.name, sid: d.sid, nd: d.nd, cct: this.device.cct, br: this.device.br, state: this.device.state, checked: false, device_node_type: d.device_node_type, enableBR: d.enableBR, enableCCT: d.enableCCT }
      })
      this.syncCommand()
    },
    device: {
      deep: true,
      handler (device, old) {
        this.bulbs.forEach(b => {
          for (const key in this.device) {
            if (this.device[key] !== this.copy[key]) {
              b[key] = this.device[key]
            }
          }
        })
        this.copy = { ...this.device }
      }
    }
  },
  created () {
    this.bulbs = this.lights.map(d => {
      return { deviceId: d.deviceId, name: d.name, sid: d.sid, nd: d.nd, cct: this.device.cct, br: this.device.br, state: this.device.state, checked: false, device_node_type: d.device_node_type, enableBR: d.enableBR, enableCCT: d.enableCCT }
    })
    this.copy = { ...this.device }
    this.$hub.$on('getCommand', this.reportCommand)
  },
  mounted () {
    // 同步一次命令
    this.syncCommand()
  },
  deactivated () {
    this.reportCommand()
  },
  methods: {
    getIcon (state) {
      if (state) {
        return require('@/assets/images/home/open.png')
      } else {
        return require('@/assets/images/home/close.png')
      }
    },
    getLightIcon (device) {
      if (device.device_node_type === 37) {
        return require('@/assets/images/device/light/classroomlight-k.png')
      } else if (device.device_node_type === 39) {
        return require('@/assets/images/device/light/blackboardlight-k.png')
      } else {
        return require('@/assets/images/device/light/device_light_e.png')
      }
    },
    syncCommand () {
      this.command.forEach(c => {
        // 同步命令至当前模板
        if (this.bulbs.map(b => b.nd).includes(c.nd)) {
          const bulbs = this.bulbs.filter(b => b.deviceId === c.deviceId && b.nd === c.nd)
          bulbs.forEach(bulb => {
            switch (c.cmd) {
              case 1:
                bulb.state = c.state
                break
              case 2:
                bulb.state = c.ring[1]
                bulb.br = c.ring[2]
                bulb.cct = c.ring[4] + (c.ring[3] << 8)
                break
            }
            bulb.checked = true
          })
        }
      })
    },
    reportCommand () {
      // 同步数据
      const command = []
      this.bulbs.filter(d => d.checked).forEach(b => {
        let cmd = {}
        if (b.state) {
          cmd = { cmd: 2, nd: b.nd, ring: [0, 1, b.br, b.cct >> 8, b.cct & 0xff, 0, 0, 0] }
        } else {
          cmd = { cmd: 1, nd: b.nd, state: 0 }
        }
        if (b.sid) {
          Object.assign(cmd, { sid: b.sid })
        }
        cmd.deviceId = b.deviceId
        // 对于多控制器的特殊处理
        let obj = this.lightsOrign.filter(item => item.nd === b.nd && item.deviceId !== b.deviceId)
        if (obj && obj.length) {
          obj.forEach(item => {
            cmd.deviceId = item.deviceId
            command.push(cmd)
          })
        } else {
          command.push(cmd)
        }
      })
      // debugger
      this.$emit('changeCommand', command, this.bulbs.filter(d => !d.checked).map(d => {
        return { deviceId: d.deviceId, nd: d.nd, sid: d.sid }
      }))
    }
  }
}
</script>

<style scoped lang="less">
.scene_add {
  margin-top: 20px;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  flex: 1;
  display: flex;
  flex-direction: row;
  padding: 0px 20px 0px 20px;
  > .left {
    flex: 1;
    padding-right: 30px;
    padding-top: 20px;
    width: 0;
    height: 100%;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
    align-content: flex-start;
    .pd20 {
      padding: 0px 20px;
    }
  }
  > .right {
    overflow-y: auto;
    padding-top: 20px;
    padding-left: 20px;
    width: 300px;
    border-left: 1px solid #DFE1E5;
    & .form {
      display: flex;
    }
  }
}
</style>
<style lang="less">
.scene_add {
  & .el-form-item__label {
    font-size: 15px;
    font-weight: 600;
    color: rgba(34, 34, 34, 1);
  }
  & .pd20 {
    & .form {
      & .slider {
        width: 130px;
      }
    }
  }
  & .form {
    display: flex;
    & .slider {
      margin-top: 5px;
      width: 150px;
      .range-slider-fill {
        background: linear-gradient(
                90deg,
                rgba(90, 208, 98, 1),
                rgba(119, 216, 87, 1)
        );
      }
      & .range-slider-rail,
      .range-slider-fill {
        height: 10px;
        border-radius: 6px;
        box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.12);
      }
      & .range-slider-knob {
        height: 20px;
        width: 20px;
        background: rgba(76, 203, 107, 1);
        box-shadow: 0px 1px 8px 1px rgba(76, 203, 107, 0.4);
        border: 0;
      }
    }
  }
}
</style>
